






































import Vue from 'vue'
import {
    COLOR_PIANTA_POTATA,
    COLOR_PIANTA_DA_POTARE,
    COLOR_PIANTA_CON_DANNI_DA_INSETTO,
    COLOR_PIANTA_CON_DANNI_DA_INSETTO_FIXED,
    COLOR_PIANTA_CON_MICOSI,
    COLOR_PIANTA_CON_MICOSI_FIXED
} from '../../costanti'
import {mapGetters} from 'vuex'

export default Vue.extend({
    data: () => ({
        COLOR_PIANTA_POTATA,
        COLOR_PIANTA_DA_POTARE,
        COLOR_PIANTA_CON_DANNI_DA_INSETTO,
        COLOR_PIANTA_CON_DANNI_DA_INSETTO_FIXED,
        COLOR_PIANTA_CON_MICOSI,
        COLOR_PIANTA_CON_MICOSI_FIXED
    }),
    computed: {
        ...mapGetters('auth', ['isAuthenticated'])
    }
})
